import { withStyles } from "@material-ui/styles";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const style = () => ({
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "#00000085",
    zIndex: "9999", // Make sure it's above other content
  },
});

const ToastModal = ({ toastMessage, toastMessageType, classes, toastUpdate , setShowModal, modalReopen, setModalReOpen}) => {
  const [isToastOpen, setIsToastOpen] = useState(false);
  const toastId = React.useRef(null);
  const navigate = useNavigate();
  const { authToken } = useSelector((state) => state.login.authData);
  const dispatch = useDispatch();
  const toastParameter = {
    position: "top-center",
    autoClose: false,
    hideProgressBar: true,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    onClose: (reason) => {
        if(!reason)
          setIsToastOpen(false);
        toastUpdate("", "", false);
        if(setShowModal && modalReopen){
          setShowModal(true)
          setModalReOpen(false)
        }
    },
  };
  const handleClose = async () =>{
      dispatch({ type: "SIGNOUT" });
      sessionStorage.removeItem('session');
      const result = await apiHandler({
        url: endpoint.USER_LOGOUT_API,
        authToken: authToken,
      });
        // window.location.href = result?.data?.main
      toastUpdate("","",false);
      setIsToastOpen(false);
      navigate("/login");
  }

  useEffect(() => {
    const message = toastMessage?.toLowerCase();
    if (
      message?.includes("session timeout") ||
      message?.includes("access token") ||
      message?.includes("authorization header")
    ) {
    handleClose();
    }else{
      let updatedMessage = toastMessage;
      const technicalKeywords = ["sql", "query", "table", "mapper"];
      if ( toastMessage && technicalKeywords.some((keyword) => new RegExp(`\\b${keyword}\\b`, "i").test(toastMessage) )) {
        updatedMessage = "There is some technical problem. Please contact the support team.";} 
    if (toastMessage && !isToastOpen) {
      if (!toast.isActive(toastId.current)) {
        setIsToastOpen(true);
        if(setShowModal && modalReopen){
          setShowModal(false)
          setModalReOpen(false)
        }
        switch (toastMessageType) {
          case "Error":
            toastId.current = toast.error(updatedMessage, toastParameter);
            break;
          case "Success":
            toastId.current = toast.success(updatedMessage, {
              ...toastParameter,
              autoClose: 3000,
            });
            break;
          case "Information":
            toastId.current = toast.info(updatedMessage, toastParameter);
            break;
          case "Warning":
            toastId.current = toast.warn(updatedMessage, toastParameter);
            break;
          default:
            break;
        }
      }
    }
  }
  }, [toastMessage, toastMessageType, toastUpdate]);

  return (
    <>
      {isToastOpen && <div className={classes.overlay}></div>}
      <ToastContainer
        toastStyle={{
          maxHeight: "250px",
          overflowY: "auto",
          wordBreak: "break-word",
        }}
      />
    </>
  );
};

export default withStyles(style)(ToastModal);
